import type { BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import { PageJson } from '@wix/thunderbolt-becky-types'
import getPagesJson from './getPagesJson'

export const getPayloadWithErrorPage = (payload: BeckyRequestPayload): BeckyRequestPayload => {
	const pageJson = getPagesJson({
		errorPageId: payload.errorPageId!,
		isResponsiveSite: payload.isResponsive === 'true',
		externalBaseUrl: payload.externalBaseUrl,
		isOneDocMigrated: !!(payload.oneDocEnabled === 'true' && payload.experiments?.includes('dm_meshLayout')),
	})

	if (!pageJson) {
		return payload
	}

	return {
		...payload,
		pages: {
			...payload.pages,
			[payload.errorPageId!]: new Promise((resolve) => resolve(pageJson)) as Promise<PageJson>,
		},
	}
}

export const maybeAppendErrorPages = (payload: BeckyRequestPayload) =>
	payload.errorPageId ? getPayloadWithErrorPage(payload) : payload
